<template>
  <v-container fluid fill-height>
    <v-layout wrap>
      <v-flex>
        <v-card>
          <v-card-text>
            <v-container fluid fill-height>
              <v-layout wrap>
                <v-flex>
                  <span class="headline">WAHANA</span>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 md6>
                  <v-container fluid>
                    <v-layout align-end justify-end>
                      <v-flex xs10 class="offset-sm-3">
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Cari"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 class="text-right">
                        <v-btn color="primary" :to="addData()" dark>+</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="tableData"
                    :search="search"
                    item-key="id"
                    no-data-text="Tidak ditemukan data wahana"
                    no-results-text="Hasil pencarian tidak ditemukan"
                    :loading="loading"
                    loading-text="pengambilan data sedang berlangsung..."
                  >
                    <template v-slot:item.action="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="secondary"
                            :to="editData(item)"
                            class="mr-2"
                            fab
                            small
                            dark
                          >
                            <v-icon v-on="on">edit</v-icon>
                          </v-btn>
                        </template>
                        <span>Ubah data</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            :to="viewData(item)"
                            class="mr-2"
                            fab
                            small
                            dark
                            v-show="false"
                          >
                            <v-icon v-on="on">subject</v-icon>
                          </v-btn>
                        </template>
                        <span>Lihat detail</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="error"
                            :to="deleteData(item)"
                            class="mr-2"
                            fab
                            small
                            dark
                            v-show="false"
                          >
                            <v-icon v-on="on">delete_forever</v-icon>
                          </v-btn>
                        </template>
                        <span>Hapus</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.bonusApplied="{ item }">
                      {{ item.bonusApplied | booleanToBahasa }}
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingError"
      top
      color="error"
      :timeout="errorTimeout"
    >
      {{ loadingError }}
      <v-btn dark text @click="isLoadingError = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      search: null,
      isLoadingError: false,
      loadingError: null,
      errorTimeout: 10000,
      mainPath: process.env.VUE_APP_ATTRACTION_PATH,
      headers: [
        { text: "Nama", value: "attractionName" },
        { text: "Bonus Berlaku?", value: "bonusApplied" },
        {
          text: "Harga Normal Umum (Senin-Jumat/Sabtu-Minggu)",
          value: "formattedNormalPrice"
        },
        { text: "Aksi", value: "action", align: "center" }
      ],
      tableData: []
    };
  },
  methods: {
    addData() {
      return this.mainPath + "/add";
    },
    editData(item) {
      return this.mainPath + "/edit/" + item.id;
    },
    viewData(item) {
      return this.mainPath + "/" + item.id;
    },
    deleteData(item) {
      return this.mainPath + "/delete/" + item.id;
    }
  },
  filters: {
    booleanToBahasa: function(value) {
      return value ? "Ya" : "Tidak";
    }
  },
  mounted: function() {
    let self = this;
    self.loading = true;
    this.axios
      .get(self.mainPath)
      .then(function(response) {
        self.tableData = response.data;
        self.isLoadingError = false;
      })
      .catch(function(error) {
        if (error.response) {
          self.loadingError = error.response.data.message;
        } else {
          self.loadingError = error;
        }
        self.isLoadingError = true;
      })
      .finally(function() {
        self.loading = false;
      });
  }
};
</script>

<style></style>
